export default {
      id: "checkmark-usage",
      viewBox: "0 0 14 14",
      url: "/" + "img/marilyn-ui.svg#checkmark",
      toString: function () {
        return this.url;
      }
    }